@if (hasFinishedLoadingScores) {
  <div
    #tooltip="nzTooltip"
    nz-tooltip
    [nzTooltipTitle]="qualificationTooltip"
    [nzTooltipColor]="'#fff'"
    nzTooltipPlacement="right"
    [nzTooltipOverlayStyle]="{ 'max-width': '600px', 'min-width': '250px' }"
    class="d-flex justify-content-end"
  >
    @if (qualificationFulfilled) {
      <div>
        <img src="assets/img/qualification/qualifications-fulfilled.svg" />
      </div>
    } @else {
      <img src="assets/img/qualification/qualifications-missing.svg" />
    }
  </div>
} @else {
  <nz-skeleton-element
    class="progress"
    [nzActive]="true"
    nzType="avatar"
    [nzSize]="'small'"
    [nzShape]="'square'"
  ></nz-skeleton-element>
}

<ng-template #qualificationTooltip>
  <wilson-shift-validations-tooltip
    (expanded)="onTooltipExpanded()"
    [workingTimeValidations]="$any(workingTimeValidations)"
    [shiftLogicValidations]="$any(shiftLogicValidations)"
    [qualificationNames]="$any(qualificationNames)"
    [professionValidations]="$any(professionValidations || null)"
  >
    <wilson-user-details [user]="user || null"></wilson-user-details>
  </wilson-shift-validations-tooltip>
</ng-template>
